import { render, staticRenderFns } from "./AppCardFooter.vue?vue&type=template&id=6f4ab889"
var script = {}
import style0 from "./AppCardFooter.vue?vue&type=style&index=0&id=6f4ab889&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports